export default {"src":"/_next/static/media/arrow-outside.85502cda.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};